import request from '@/utils/request'

export function getList(params = {}) {
  return request({
    url: '/report_form/predit/channel_order',
    method: 'get',
    params
  })
}
export function getwechatList(params = {}) {
  return request({
    url: '/report_form/predit/miniprogram_channel_order',
    method: 'get',
    params
  })
}
export function novel_getwechatList(params = {}) {
  return request({
    url: '/report_form/predit/novel_miniprogram_channel_order',
    method: 'get',
    params
  })
}

export function setCost(data = {}) {
  return request({
    url: '/report_form/cost/channel',
    method: 'post',
    data
  })
}
export function setWechatCost(data = {}) {
  return request({
    url: '/report_form/cost/miniprogram_channel',
    method: 'post',
    data
  })
}

export function setCost1(data = {}) {
  return request({
    url: '/report_form/cost/channel_group',
    method: 'post',
    data
  })
}

export function exportChannelReport(data = {}) {
  return request({
    url: '/report_form/export/channel_order',
    method: 'post',
    data
  })
}
export function exportWechatReport(data = {}) {
  return request({
    url: '/report_form/export/miniprogram_channel_order',
    method: 'post',
    data
  })
}
export function noval_exportWechatReport(data = {}) {
  return request({
    url: '/report_form/export/novel_miniprogram_channel_order',
    method: 'post',
    data
  })
}

export function getList1(params = {}) {
  return request({
    url: '/report_form/predit/channel_form_group',
    method: 'get',
    params
  })
}
